const base64ToObject = <Result>(base64: string): Result => {
  return JSON.parse(atob(base64)) as Result;
};

export default base64ToObject;
